import { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Check, Plus, Trash2 } from 'lucide-react';
import { errMsg } from './labApi';

const TestRow = ({ t, api, onChange }) => {
  const [rate, setRate] = useState(String(t.rate));
  const save = async (patch) => {
    try { await api.put(`/tests/${t.id}`, { name: t.name, rate: parseFloat(rate) || 0, active: t.active, ...patch }); toast.success(`${t.name} updated`); onChange(); }
    catch (e) { toast.error(errMsg(e, 'Update failed')); }
  };
  const remove = async () => {
    if (!window.confirm(`Remove ${t.name}?`)) return;
    try { await api.del(`/tests/${t.id}`); onChange(); } catch (e) { toast.error(errMsg(e, 'Delete failed')); }
  };
  return (
    <div className={`flex items-center gap-2 px-3 py-1.5 ${t.active ? '' : 'opacity-50'}`}>
      <span className="flex-1 text-sm font-semibold">{t.name}</span>
      <Input inputMode="decimal" value={rate} onChange={(e) => setRate(e.target.value.replace(/[^0-9.]/g, ''))} className="h-7 w-24 text-right text-sm" data-testid={`lab-rate-input-${t.id}`} />
      <Button size="sm" variant="ghost" className="h-7 px-2 text-emerald-600" onClick={() => save({})} data-testid={`lab-rate-save-${t.id}`}><Check className="h-4 w-4" /></Button>
      <Button size="sm" variant="outline" className="h-7 text-xs" onClick={() => save({ active: !t.active })} data-testid={`lab-test-toggle-${t.id}`}>{t.active ? 'Hide' : 'Show'}</Button>
      <Button size="sm" variant="ghost" className="h-7 px-2 text-red-500" onClick={remove} data-testid={`lab-test-delete-${t.id}`}><Trash2 className="h-4 w-4" /></Button>
    </div>
  );
};

export const LabTestsManager = ({ api, tests, onChange }) => {
  const [name, setName] = useState('');
  const [rate, setRate] = useState('');
  const add = async () => {
    if (!name.trim()) return;
    try { await api.post('/tests', { name, rate: parseFloat(rate) || 0 }); setName(''); setRate(''); toast.success('Test added'); onChange(); }
    catch (e) { toast.error(errMsg(e, 'Could not add')); }
  };
  return (
    <Card className="p-5 space-y-3" data-testid="lab-tests-manager">
      <h3 className="font-bold">Test List & Rates</h3>
      <div className="flex gap-2">
        <Input placeholder="New test name" value={name} onChange={(e) => setName(e.target.value)} className="h-9" data-testid="lab-new-test-name" />
        <Input placeholder="Rate" inputMode="decimal" value={rate} onChange={(e) => setRate(e.target.value.replace(/[^0-9.]/g, ''))} className="h-9 w-28" data-testid="lab-new-test-rate" />
        <Button className="h-9 bg-teal-700 text-white" onClick={add} data-testid="lab-new-test-add"><Plus className="h-4 w-4 mr-1" /> Add</Button>
      </div>
      <div className="border rounded-lg divide-y max-h-[60vh] overflow-y-auto">
        {tests.map((t) => <TestRow key={`${t.id}-${t.rate}-${t.active}`} t={t} api={api} onChange={onChange} />)}
      </div>
    </Card>
  );
};
